import React, {useEffect, useState} from "react";
import Section1 from "../../components/Section1";
import LayoutsList from "../../components/LayoutsList";
import { useNavigate, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass, faXmark } from "@fortawesome/free-solid-svg-icons";
import { apiUrl, assetsUrl } from "../../config/Config";
import axios from "axios";

import googleicon from '../../assets/images/google_icon.png';
import { useDispatch, useSelector } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";

import { GoogleLogin } from '@react-oauth/google';
import { jwtDecode } from "jwt-decode";

const Login = () => {
    let navigate = useNavigate();
    const dispatch = useDispatch(); 
    const location = useLocation();
    console.log('state frompage >>', location?.state?.frompage);
    const inkcustomerdata = useSelector((store) => store.userReducer.inkcustomerdata);

    // console.log('inkcustomerdata >>', inkcustomerdata);

    const [fullname, setfullname] = useState("");
    const [emailaddress, setemailaddress] = useState("");
    const [phonenumber, setphonenumber] = useState("");
    const [password, setpassword] = useState("");
    const [repassword, setrepassword] = useState("");

    const [emailverfyloading, setemailverfyloading] = useState(false);

    const [emailaddresserrormessage, setemailaddresserrormessage] = useState("");
    const [passworderrormessage, setpassworderrormessage] = useState("");
    const [showloading, setshowloading] = useState(false);

    const isValidEmail = (email) => {
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return regex.test(email);
    };

    const handlesignupwithgoogle = async(token) => {
      setshowloading(true);
      var data = {
        token: token,
      };
  
      try {
        const res = await axios.post(apiUrl + "userregisterviagoogle", data, {
          headers: { "Content-Type": "application/json" },
        });
        if (res.data.status === "success") {
          setshowloading(false);
          dispatch({ type: "inkcustomerdata", payload: res.data.data })
          const frompagetologin = localStorage.getItem("frompagetologin");
            if(frompagetologin) {
              localStorage.removeItem("frompagetologin");
              window.location.href = frompagetologin;
            } else {
              navigate('/user-profile');
            }
          // navigate('/user-profile');
        } else {
          alert(res.data.message || "Registration Failed.");
          setshowloading(false);
        }
      } catch (err) {
        console.error("API Error:", err);
        alert("Network or Server Error!");
        setshowloading(false);
      }
      setshowloading(false);
    }

    const handleSuccess = (credentialResponse) => {
      // const decoded = jwtDecode(credentialResponse.credential);
      // console.log("User Info:", decoded);
      const token = credentialResponse.credential;
      console.log("Token:", token);
      handlesignupwithgoogle(token);
  
      // Send this token to your backend (Laravel API)
    };

    const handlesignupfunc = async() => {
        // navigate('/')
        var isemailaddresserror = false;
        var ispassworderror = false;

        if(emailaddress && isValidEmail(emailaddress)) {
          isemailaddresserror = false;
          setemailaddresserrormessage("");
        } else {
          if (emailaddress) {
            isemailaddresserror = true;
            setemailaddresserrormessage("Invalid Email Address.");
          } else {
            isemailaddresserror = true;
            setemailaddresserrormessage("Email-id cannot be empty.");
          }
        }

        if(password) {
          ispassworderror = false;
          setpassworderrormessage("");
        } else {
          ispassworderror = true;
          setpassworderrormessage("Password cannot be empty.");
        }

        if(!isemailaddresserror && !ispassworderror) {

        } else {
          return;
        }

        var data = {
          emailaddress: emailaddress,
          password: password
        }

        setshowloading(true);
        const headers = {
          headers: {
              'Content-Type': 'application/json',
              'Access-Control-Allow-Origin': '*'
          }
        }
        let resp = await axios.post(apiUrl + 'user-login', data, headers).then((res) => {
          if(res.data.status == 'success') {
            setshowloading(false);
            dispatch({ type: "inkcustomerdata", payload: res.data.data });
            const frompagetologin = localStorage.getItem("frompagetologin");
            if(frompagetologin) {
              localStorage.removeItem("frompagetologin");
              window.location.href = frompagetologin;
            } else {
              navigate('/user-profile');
            }
            // navigate('/user-profile');
          } else {
            setshowloading(false);
            

            if(res.data.message == "Email address not verified") {
              navigate("/verify-email-address", {
                state: {
                  semail: emailaddress,
                  screen: "signup",
                },
              });
            } else {
              toast.error(res.data.message);
            }

            
            // alert(res.data.message);
          }
          setshowloading(false);
        } ).catch((err) => {
          setshowloading(false);
            alert(err.message)
        })
        setshowloading(false);
        console.log('handle login func data >>', data);
    }

    

    const resendotpfunc = async() => {
      if(emailaddress && isValidEmail(emailaddress)) {

      } else {
        if (emailaddress) {
          alert("Invalid Email Address.");
        } else {
          alert("Enter email-id to verify & reset password.");
        }
        return;
      }

      var data = {
        emailaddress: emailaddress,
      };

      try {
        const res = await axios.post(apiUrl + "verifyemail-to-sendotp", data, {
          headers: { "Content-Type": "application/json" },
        });
        if (res.data.status === "success") {
          setemailverfyloading(false);
          navigate('/verify-email-address', {
            state: {
              semail: emailaddress,
              screen: "resset-password"
            }
          } )
        } else {
          alert(res.data.message || "Registration Failed.");
          setemailverfyloading(false);
        }
      } catch (err) {
        console.error("API Error:", err);
        alert("Network or Server Error!");
        setemailverfyloading(false);
      }
      setemailverfyloading(false);

      
    }

    useEffect(() => {
      if(inkcustomerdata && Object.keys(inkcustomerdata)?.length > 0) {
          navigate('/user-profile')
      } else {

      }
    }, [])
    

    return (
      <div className="homepage-layout">
        {/* <ToastContainer
                position="top-right"
                toastClassName="custom-toast"
                bodyClassName="custom-toast-body"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                pauseOnHover
                draggable
                theme="colored"
              /> */}
        <section>
          <div className=" findlayout_section1main regsiterpagemaindiv">
            <div className="container">
              <div className="registermaindiv">
                <p className="section1title">
                  <span className="gradient-head">Login</span>
                </p>
                <div className="register-inputdiv">
                  <label>Email Address *</label>
                  <input
                    type="text"
                    value={emailaddress}
                    onChange={(t) => {
                      setemailaddress(t.target.value);
                    }}
                    className="register-textinput form-control"
                    placeholder="Enter your email address"
                  />
                </div>
                {emailaddresserrormessage ? (
                  <p className="register-error-message">
                    {emailaddresserrormessage}
                  </p>
                ) : null}
                <div className="register-inputdiv">
                      <label>Password *</label>
                      <input
                        type="password"
                        value={password}
                        onChange={(t) => {
                          setpassword(t.target.value);
                        }}
                        className="register-textinput form-control"
                        placeholder="Enter your password"
                      />
                      {passworderrormessage ? (
                      <p className="register-error-message">
                        {passworderrormessage}
                      </p>
                    ) : null}
                    </div>
                    <div className="resetpassworddiv">
                      <p style={{cursor: 'pointer'}} onClick={() => {resendotpfunc()}}>Forgot Password ?</p>
                    </div>
                <div className="registersubmitbtn" onClick={() => {
                    handlesignupfunc()
                }}>
                  <p>Sign In</p>
                </div>
                <div className="orborderdiv">
                  <div className="orderline1"></div>
                  <div className="ortextdiv">
                    <p>OR</p>
                  </div>
                  <div className="orderline1"></div>
                </div>
                <div className="continuewithgoogleicon">
                  <GoogleLogin
                                    // onSuccess={(res) => {
                                    //   // console.log('res >>', res)
                                    //   const user = jwtDecode(res.credential);
                                    //   handlesignupwithgoogle(user)
                                    //   // console.log('user >>', user);
                                      
                                    //   // console.log('user given name >>', user?.given_name);
                  
                  
                                    // }}
                                    onSuccess={handleSuccess}
                                    onError={() => console.log("Login Failed")}
                                  />
                </div>
                <div className="alreadyhaveaccountdiv">
                    <p className="alreadyhaveaccounttext">New User ?</p>
                    <p className="signintext" onClick={() => {navigate('/register')}}>Sign Up</p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
}

export default Login